export default "__VITE_ASSET__aa364206__"